<template>
  <ValidationObserver ref="form" v-slot="{ failed }">
    <div class="row">
      <div class="col-12 col-lg-3 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{ required: 'Favor seleccione región.' }"
        >
          <CustomDropDown
            v-model="filter.region"
            label="Región:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalogRegions"
            placeholder="Seleccione"
            :disabled="!selectRegion"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-lg-3 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{ required: 'Favor seleccione municpio.' }"
        >
          <CustomDropDown
            v-model="filter.municipality"
            label="Municipio:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalogMunicipalities"
            placeholder="Seleccione"
            :disabled="
              !selectMunicipality || (selectMunicipality && !filter.region)
            "
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-lg-4 pt-2">
        <ValidationProvider
          v-slot="{ errors, validate }"
          mode="lazy"
          rules="required"
          :custom-messages="{ required: 'Favor seleccione una escuela.' }"
        >
          <CustomDropDown
            v-model="filter.school"
            label="Escuela:"
            regular-label
            fieldkey="id"
            fieldname="name"
            :options="catalogSchools"
            placeholder="Seleccione"
            :disabled="!filter.municipality"
            :error="errors[0]"
            :custom-error-msg="errors[0]"
            @input="validate"
          />
        </ValidationProvider>
      </div>
      <div class="col-12 col-lg-2 pt-4">
        <div class="h-100 d-flex justify-content-end align-items-end">
          <div :class="['w-100', { 'pb-lg-4': failed }]">
            <ActionButton
              text="Buscar"
              variant="success"
              i="fas fa-search"
              class="btn-block"
              @click="search"
            />
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import { SearchMixin } from '../search.mixin';

export default {
  name: 'SchoolRecommendationSearch',
  mixins: [SearchMixin],
  components: {
    CustomDropDown,
    ActionButton,
  },
  async created() {
    if (this.selectRegion) {
      await this.getRegions();
    } else if (this.region) {
      this.filter.region = this.region;
    }
    if (!this.selectMunicipality && this.municipality) {
      this.filter.municipality = this.municipality;
    }
  },
};
</script>
